export const RECEIVE_TEMPLATE_BUILDER =
  "TEMPLATE_BUILDER:RECEIVE_TEMPLATE_BUILDER";
export const UPDATE_TEMPLATE_BUILDER =
  "TEMPLATE_BUILDER:UPDATE_TEMPLATE_BUILDER";

export const SET_STATE_CHANGED = "TEMPLATE_BUILDER:SET_STATE_CHANGED";

export const REVALIDATE_TEMPLATE_BUILDER =
  "TEMPLATE_BUILDER:REVALIDATE_TEMPLATE_BUILDER";

export const IS_FETCHING_TEMPLATE_BUILDER_MODEL =
  "TEMPLATE_BUILDER:IS_FETCHING_MODEL";
export const UPDATE_DATA_TEMPLATE = "TEMPLATE_BUILDER:UPDATE_DATA_TEMPLATE";
export const UPDATE_DATA_TEMPLATE_ITEMS =
  "TEMPLATE_BUILDER:UPDATE_DATA_TEMPLATE_ITEMS";
export const UPDATE_DATA_TEMPLATE_ITEM =
  "TEMPLATE_BUILDER:UPDATE_DATA_TEMPLATE_ITEM";
export const UPDATE_PRESENTATION_TEMPLATE =
  "TEMPLATE_BUILDER:UPDATE_PRESENTATION_TEMPLATE";
export const UPDATE_PRESENTATION_TEMPLATE_ITEMS =
  "TEMPLATE_BUILDER:UPDATE_PRESENTATION_TEMPLATE_ITEMS";
export const UPDATE_PRESENTATION_TEMPLATE_ITEM =
  "TEMPLATE_BUILDER:UPDATE_PRESENTATION_TEMPLATE_ITEM";
export const UPDATE_D_AND_P_TEMPLATE_ITEMS =
  "TEMPLATE_BUILDER:UPDATE_D_AND_P_ITEMS";
export const ADD_NEW_D_AND_P_TEMPLATE_ITEM =
  "TEMPLATE_BUILDER:ADD_NEW_D_AND_P_TEMPLATE_ITEM";
export const DELETE_D_AND_P_TEMPLATE_ITEM =
  "TEMPLATE_BUILDER:DELETE_D_AND_P_TEMPLATE_ITEM";
export const UPDATE_DETAIL_TEMPLATES =
  "TEMPLATE_BUILDER:UPDATE_DETAIL_TEMPLATES";
export const UPDATE_DETAIL_TEMPLATES_ORDER =
  "TEMPLATE_BUILDER:UPDATE_DETAIL_TEMPLATES_ORDER";

export const RECEIVE_EDIT_ROW = "TEMPLATE_BUILDER:RECEIVE_EDIT_ROW";
export const IS_FETCHING_EDIT_ROW = "TEMPLATE_BUILDER:IS_FETCHING_EDIT_ROW";
export const UPDATE_EDIT_ROW = "TEMPLATE_BUILDER:UPDATE_EDIT_ROW";

export const RECEIVE_SQL_QUERY = "TEMPLATE_BUILDER:RECEIVE_SQL_QUERY";
export const IS_FETCHING_SQL_QUERY = "TEMPLATE_BUILDER:IS_FETCHING_SQL_QUERY";

export const RECEIVE_TB_MODELS = "TEMPLATE_BUILDER:RECEIVE_MODELS";
